import { render, staticRenderFns } from "./CustomerRating.vue?vue&type=template&id=e44ca4c4&scoped=true"
import script from "./CustomerRating.vue?vue&type=script&lang=js"
export * from "./CustomerRating.vue?vue&type=script&lang=js"
import style0 from "./CustomerRating.vue?vue&type=style&index=0&id=e44ca4c4&prod&lang=css"
import style1 from "./CustomerRating.vue?vue&type=style&index=1&id=e44ca4c4&prod&lang=sass&scoped=true"
import style2 from "./CustomerRating.vue?vue&type=style&index=2&id=e44ca4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44ca4c4",
  null
  
)

export default component.exports